import { createThemedUseStyles } from "theme";

export default createThemedUseStyles(() => ({
  /*
   * The prompt sits in the nav bar's action area. Wrapping the message would add a second
   * line of text and grow the whole bar's height, so it always stays on one line.
   */
  message: {
    whiteSpace: "nowrap"
  }
}));
